/*
 * Current week per date
 */
export const FETCH_CURRENT_WEEK_REFILLS_PER_DATE_BEGIN =
  "FETCH_CURRENT_WEEK_REFILLS_PER_DATE_BEGIN";
export const FETCH_CURRENT_WEEK_REFILLS_PER_DATE_FAILURE =
  "FETCH_CURRENT_WEEK_REFILLS_PER_DATE_FAILURE";
export const FETCH_CURRENT_WEEK_REFILLS_PER_DATE_SUCCESS =
  "FETCH_CURRENT_WEEK_REFILLS_PER_DATE_SUCCESS";

/*
 * Current week count
 */
export const FETCH_CURRENT_WEEK_REFILLS_COUNT_BEGIN =
  "FETCH_CURRENT_WEEK_REFILLS_COUNT_BEGIN";
export const FETCH_CURRENT_WEEK_REFILLS_COUNT_FAILURE =
  "FETCH_CURRENT_WEEK_REFILLS_COUNT_FAILURE";
export const FETCH_CURRENT_WEEK_REFILLS_COUNT_SUCCESS =
  "FETCH_CURRENT_WEEK_REFILLS_COUNT_SUCCESS";

/*
 * Current month per date
 */
export const FETCH_CURRENT_MONTH_REFILLS_PER_DATE_BEGIN =
  "FETCH_CURRENT_MONTH_REFILLS_BEGIN";
export const FETCH_CURRENT_MONTH_REFILLS_PER_DATE_FAILURE =
  "FETCH_CURRENT_MONTH_REFILLS_FAILURE";
export const FETCH_CURRENT_MONTH_REFILLS_PER_DATE_SUCCESS =
  "FETCH_CURRENT_MONTH_REFILLS_SUCCESS";

/*
 * Current month count
 */
export const FETCH_CURRENT_MONTH_REFILLS_COUNT_BEGIN =
  "FETCH_CURRENT_MONTH_REFILLS_COUNT_BEGIN";
export const FETCH_CURRENT_MONTH_REFILLS_COUNT_FAILURE =
  "FETCH_CURRENT_MONTH_REFILLS_COUNT_FAILURE";
export const FETCH_CURRENT_MONTH_REFILLS_COUNT_SUCCESS =
  "FETCH_CURRENT_MONTH_REFILLS_COUNT_SUCCESS";

/*
 * Current year per date
 */
export const FETCH_CURRENT_YEAR_REFILLS_PER_DATE_BEGIN =
  "FETCH_CURRENT_YEAR_REFILLS_PER_DATE_BEGIN";
export const FETCH_CURRENT_YEAR_REFILLS_PER_DATE_FAILURE =
  "FETCH_CURRENT_YEAR_REFILLS_PER_DATE_FAILURE";
export const FETCH_CURRENT_YEAR_REFILLS_PER_DATE_SUCCESS =
  "FETCH_CURRENT_YEAR_REFILLS_PER_DATE_SUCCESS";

/*
 * Current year count
 */
export const FETCH_CURRENT_YEAR_REFILLS_COUNT_BEGIN =
  "FETCH_CURRENT_YEAR_REFILLS_COUNT_BEGIN";
export const FETCH_CURRENT_YEAR_REFILLS_COUNT_FAILURE =
  "FETCH_CURRENT_YEAR_REFILLS_COUNT_FAILURE";
export const FETCH_CURRENT_YEAR_REFILLS_COUNT_SUCCESS =
  "FETCH_CURRENT_YEAR_REFILLS_COUNT_SUCCESS";



// WEBPACK FOOTER //
// ./src/constants/refillsActionsTypes.js